import { SvgIcon } from '@mui/material';
import ArrowUp from '../../../icons/svg/sort_arrow_up.svg?react';
import ArrowDown from '../../../icons/svg/sort_arrow_down.svg?react';
import { FC } from 'react';

type Props = { className?: string };

export const SortAscendingIcon: FC<Props> = ({ className }) => (
  <SvgIcon className={className} component={ArrowUp} />
);
export const SortDescendingIcon: FC<Props> = ({ className }) => {
  return <SvgIcon className={className} component={ArrowDown} />;
};
